'use client';

import { ElementContainer } from '..';
import { CustomImage as Image } from '..';
import React from 'react';
import { PowerPlugId } from 'utils/powerPlugAvailability';

export type PowerPlugCardProps = {
  plugId?: PowerPlugId;
  title: React.ReactNode;
  subtitle: string | (() => React.ReactNode) | React.ReactNode;
  description: string;
  image: string;
  alt: string;
  style: {
    className?: string;
    background?: React.CSSProperties;
    backgroundSvg?: React.ReactNode;
  };
  onExplore: () => void;
  exploreLabel?: string;
};

export const PowerPlugCard = ({
  title,
  subtitle,
  description,
  image,
  alt,
  style,
  onExplore,
  exploreLabel = 'Explore',
}: PowerPlugCardProps) => (
  <ElementContainer
    className={`relative ${style.className ?? ''}`} // Make sure it's relative!
    style={style.background}
  >
    {/* SVG Background */}
    {style.backgroundSvg && (
      <div
        className="svg-bg"
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        {React.isValidElement(style.backgroundSvg)
          ? React.cloneElement(
              style.backgroundSvg as React.ReactElement<any>,
              {
                style: {
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  position: 'absolute',
                  inset: 0,
                  ...((style.backgroundSvg as React.ReactElement<any>).props
                    .style || {}),
                },
                preserveAspectRatio: 'none', // Optionally stretch
              } as any,
            )
          : style.backgroundSvg}
      </div>
    )}

    <div className="text-container" style={{ position: 'relative', zIndex: 1 }}>
      <div className="title-row">
        <h4>{title}</h4>
        <span className="subtitle">
          {typeof subtitle === 'function' ? subtitle() : subtitle}
        </span>
      </div>
      <p className="description">{description}</p>
      <div className="cta-container">
        <button className="primary" onClick={onExplore}>
          {exploreLabel}
        </button>
      </div>
    </div>
    <div
      className="image-container"
      style={{ position: 'relative', zIndex: 1 }}
    >
      <Image loading="eager" src={image} fill alt={alt} />
    </div>
  </ElementContainer>
);
